import React, { useCallback, useRef, useState } from 'react';
import './index.scss';
import { message, Modal, Dropdown } from 'antd';
import { request } from '@/fetch/core';
import { HttpStatusCode } from '@/fetch/core/constant';
import dayjs from 'dayjs';
import RemoteCallModal from '@/components/RemoteCallModal';
import RemoveStop from '../RemoveStop';
import RemoteCall from '../RemoteCall';
import MicroPhone from '../MicroPhone';
import SpeedLimitModal from './SpeedLimitModal';
import SimInfoModal from './SimInfoModal';

const TakeoverSetting = (props: {
  vehicleName: string;
  cockpitNumber: string;
  takeOverBySelf: boolean;
  audioUrl?: string;
}) => {
  const { vehicleName, cockpitNumber, takeOverBySelf, audioUrl } = props;
  const [modalVisible, setModalVisible] = useState(false);
  const [remoteCallModalVisible, setRemoteCallModalVisible] = useState(false);
  const [scheduleInfo, setScheduleInfo] = useState('');
  const [dropdownBtnsShow, setDropdownBtnsShow] = useState(false);

  const [speedLimitModalVisible, setSpeedLimitModalVisible] = useState(false);
  const [simInfoModalVisible, setSimInfoModalVisible] = useState(false);

  // 车辆发车逻辑
  const handleVehicleDispatch = async () => {
    if (!vehicleName) {
      message.error('无法获取车辆信息');
      return;
    }

    try {
      const res = await request({
        method: 'POST',
        path: '/monitor/web/schedule/reloadTask',
        body: {
          vehicleName: vehicleName,
          timeStamp: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        },
      });

      if (res.code === HttpStatusCode.Success) {
        message.success('车辆发车指令已下发');
      } else {
        message.error(res.message || '车辆发车指令下发失败');
      }
    } catch (error) {
      message.error('车辆发车指令下发失败');
    }
  };
  // 调度路线逻辑
  const handleScheduleRoute = async () => {
    if (!vehicleName) {
      message.error('无法获取车辆信息');
      return;
    }

    try {
      const res = await request({
        method: 'POST',
        path: '/monitor/web/schedule/getScheduleRoute',
        body: {
          vehicleName: vehicleName,
          timeStamp: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        },
      });

      if (res.code === HttpStatusCode.Success) {
        if (res.data) {
          // 按index排序stopList
          const sortedStops = res.data.stopList.sort(
            (a: any, b: any) => a.index - b.index
          );
          // 用逗号拼接stopName
          const stopNames = sortedStops
            .map((stop: any) => stop.stopName)
            .join(', ');

          setScheduleInfo(`调度路线: ${stopNames}`);
          setModalVisible(true);
        }
      } else {
        message.error(res.message || '获取调度路线失败');
      }
    } catch (error) {
      message.error('获取调度路线失败');
    }
  };
  const handleLimitSpeed = () => {
    setSpeedLimitModalVisible(true);
    setDropdownBtnsShow(false);
  };
  const handleCloseLimitSpeedModal = useCallback(() => {
    setSpeedLimitModalVisible(false);
  }, [vehicleName]);

  const handleClickSimInfo = () => {
    setSimInfoModalVisible(true);
  };

  // 创建下拉菜单内容
  const dropdownContent = (
    <div className="vehicle-command-panel" onClick={(e) => e.stopPropagation()}>
      {/* 第二行：车辆发车和查看调度 */}
      <div className="command-row">
        <button
          className="vehicle-command-btn"
          onClick={(e) => {
            e.stopPropagation();
            setDropdownBtnsShow(false);
            handleVehicleDispatch();
          }}
        >
          车辆发车
        </button>
        <button
          className="vehicle-command-btn"
          onClick={(e) => {
            e.stopPropagation();
            setDropdownBtnsShow(false);
            handleScheduleRoute();
          }}
        >
          查看调度
        </button>
      </div>

      <div className="command-row">
        <RemoteCall
          vehicleName={vehicleName}
          cockpitNumber={cockpitNumber}
          closeDropdown={() => setDropdownBtnsShow(false)}
        />
        <RemoveStop
          vehicleName={vehicleName}
          cockpitNumber={cockpitNumber}
          takeOverBySelf={takeOverBySelf}
          closeDropdown={() => setDropdownBtnsShow(false)}
        />
      </div>

      <div className="command-row">
        <MicroPhone
          audioUrl={audioUrl!}
          closeDropdown={() => setDropdownBtnsShow(false)}
        />
        <button className="vehicle-command-btn" onClick={handleLimitSpeed}>
          车辆限速
        </button>
      </div>
      <div className="command-row">
        <button className="vehicle-command-btn" onClick={handleClickSimInfo}>
          网络信息
        </button>
      </div>
    </div>
  );

  return (
    <>
      <Dropdown
        dropdownRender={() => dropdownContent}
        trigger={['click']}
        placement="topCenter"
        open={dropdownBtnsShow}
        onOpenChange={() => setDropdownBtnsShow(!dropdownBtnsShow)}
      >
        <li className="btn-item vehicle-command">
          <i>车辆指令</i>
        </li>
      </Dropdown>

      <Modal
        title="调度路线信息"
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
      >
        <pre>{scheduleInfo}</pre>
      </Modal>

      <RemoteCallModal
        visible={remoteCallModalVisible}
        vehicleName={props.vehicleName}
        setVisible={setRemoteCallModalVisible}
      />

      <SpeedLimitModal
        visible={speedLimitModalVisible}
        vehicleName={vehicleName}
        handleCloseLimitSpeedModal={handleCloseLimitSpeedModal}
      />

      {simInfoModalVisible && (
        <SimInfoModal
          visible={simInfoModalVisible}
          vehicleName={vehicleName}
          onClose={() => setSimInfoModalVisible(false)}
        />
      )}
    </>
  );
};

export default React.memo(TakeoverSetting);
